<script>
  import Button from './Button.svelte';
  import { contactGroups, eventInfo, legalLinks, socialLinks } from '../data/footer.js';
</script>

<footer class="site-footer">
  <div class="footer-frame">
    <div class="footer-main">
      <section class="event-column" aria-label="Информация о событии">
        <div class="event-copy">
          <p class="event-date">{eventInfo.date}</p>
          <p class="event-address">{eventInfo.address}</p>
        </div>

        <Button
          href={eventInfo.ticketHref}
          label={eventInfo.ticketLabel}
          target={eventInfo.ticketTarget}
          rel={eventInfo.ticketRel}
          variant="light"
        />

        {#if socialLinks.length}
          <div class="social-list event-social-list" aria-label="Социальные сети">
            {#each socialLinks as social}
              <a class="social-link {social.icon}" href={social.href} target="_blank" rel="noreferrer" aria-label={social.label}>
                {#if social.icon === 'vk'}
                  <svg viewBox="0 0 32 32" aria-hidden="true"><path d="M17.2 23.4c-7.3 0-11.5-5-11.7-13.4h3.7c.1 6.2 2.8 8.8 5 9.4V10h3.5v5.4c2.2-.2 4.5-2.6 5.3-5.4h3.5c-.6 3.5-3.1 5.9-4.8 6.9 1.7.8 4.4 2.9 5.4 6.5h-3.9c-.8-2.7-2.9-4.8-5.5-5v5h-.5Z" /></svg>
                {:else}
                  <svg viewBox="0 0 32 32" aria-hidden="true"><path d="M28.7 10.4c-.3-1.3-1.4-2.3-2.7-2.6C23.7 7.2 16 7.2 16 7.2s-7.7 0-10 .6c-1.3.3-2.3 1.3-2.7 2.6-.6 2.3-.6 5.6-.6 5.6s0 3.3.6 5.6c.3 1.3 1.4 2.3 2.7 2.6 2.3.6 10 .6 10 .6s7.7 0 10-.6c1.3-.3 2.3-1.3 2.7-2.6.6-2.3.6-5.6.6-5.6s0-3.3-.6-5.6ZM13.3 20V12l7 4-7 4Z" /></svg>
                {/if}
              </a>
            {/each}
          </div>
        {/if}
      </section>

      <div class="contacts-grid">
        {#each contactGroups as group}
          <section class="contact-column">
            <h2>{group.title}</h2>
            <ul>
              {#each group.items as item}
                <li>
                  <span>{item.label}</span>
                  {#if item.href}
                    <a href={item.href} target={item.href.startsWith('http') ? '_blank' : undefined} rel={item.href.startsWith('http') ? 'noreferrer' : undefined}>{item.value}</a>
                  {:else}
                    <span class="contact-value">{item.value}</span>
                  {/if}
                </li>
              {/each}
            </ul>

            {#if group.title === 'Контакты' && socialLinks.length}
              <div class="social-list contact-social-list" aria-label="Социальные сети">
                {#each socialLinks as social}
                  <a class="social-link {social.icon}" href={social.href} target="_blank" rel="noreferrer" aria-label={social.label}>
                    {#if social.icon === 'vk'}
                      <svg viewBox="0 0 32 32" aria-hidden="true"><path d="M17.2 23.4c-7.3 0-11.5-5-11.7-13.4h3.7c.1 6.2 2.8 8.8 5 9.4V10h3.5v5.4c2.2-.2 4.5-2.6 5.3-5.4h3.5c-.6 3.5-3.1 5.9-4.8 6.9 1.7.8 4.4 2.9 5.4 6.5h-3.9c-.8-2.7-2.9-4.8-5.5-5v5h-.5Z" /></svg>
                    {:else}
                      <svg viewBox="0 0 32 32" aria-hidden="true"><path d="M28.7 10.4c-.3-1.3-1.4-2.3-2.7-2.6C23.7 7.2 16 7.2 16 7.2s-7.7 0-10 .6c-1.3.3-2.3 1.3-2.7 2.6-.6 2.3-.6 5.6-.6 5.6s0 3.3.6 5.6c.3 1.3 1.4 2.3 2.7 2.6 2.3.6 10 .6 10 .6s7.7 0 10-.6c1.3-.3 2.3-1.3 2.7-2.6.6-2.3.6-5.6.6-5.6s0-3.3-.6-5.6ZM13.3 20V12l7 4-7 4Z" /></svg>
                    {/if}
                  </a>
                {/each}
              </div>
            {/if}
          </section>
        {/each}
      </div>
    </div>

    <div class="footer-bottom">
      <p class="copyright">©2026 Индустрия ИИ</p>

      <nav class="legal-nav" aria-label="Юридические ссылки">
        {#each legalLinks as link}
          <a href={link.href}>{link.label}</a>
        {/each}
      </nav>
    </div>
  </div>
</footer>

<style>
  .site-footer {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 64px 0 48px;
    background: #000000;
    color: #ffffff;
  }

  .footer-frame {
    display: flex;
    width: min(100%, 1440px);
    flex-direction: column;
    gap: 24px;
    padding: 0 64px;
    box-sizing: border-box;
  }

  .footer-main {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }

  .event-column,
  .contact-column,
  .footer-bottom > * {
    padding: 0 12px;
  }

  .event-column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
  }

  .event-copy {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .event-date,
  .event-address,
  .contact-column h2,
  .contact-column ul,
  .copyright {
    margin: 0;
  }

  .event-date {
    font-size: 28px;
    font-weight: 400;
    line-height: 36px;
  }

  .event-address {
    max-width: 260px;
    color: #e7b962;
    font-size: 20px;
    font-weight: 400;
    line-height: 1.2;
  }

  .social-list {
    display: flex;
    gap: 24px;
    align-items: center;
    padding-top: 8px;
  }

  .contact-social-list {
    display: none;
  }

  .social-link {
    display: inline-flex;
    width: 32px;
    height: 32px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #e7b962;
    color: #000000;
    text-decoration: none;
  }

  .social-link svg {
    width: 22px;
    height: 22px;
    fill: currentColor;
  }

  .social-link:hover,
  .social-link:focus-visible {
    background: #ffffff;
  }

  .contacts-grid {
    display: contents;
  }

  .contact-column {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .contact-column h2 {
    font-size: 28px;
    font-weight: 400;
    line-height: 28px;
  }

  .contact-column ul {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0;
    list-style: none;
  }

  .contact-column li {
    display: flex;
    flex-wrap: wrap;
    gap: 0 10px;
    align-items: center;
    color: #ffffff;
    font-size: 18px;
    font-weight: 300;
    line-height: 1.2;
  }

  .contact-column a,
  .legal-nav a {
    color: #e7b962;
    text-decoration: none;
  }

  .contact-column a,
  .contact-column .contact-value {
    font-weight: 500;
  }

  .contact-column .contact-value {
    color: #e7b962;
  }

  .contact-column a:hover,
  .contact-column a:focus-visible,
  .legal-nav a:hover,
  .legal-nav a:focus-visible {
    color: #ffffff;
    text-decoration: none;
  }

  .footer-separator {
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.25);
  }

  .footer-bottom {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 24px 0;
    width: 100%;
  }

  .copyright {
    color: #ffffff;
    font-size: 14px;
    font-weight: 300;
    line-height: 32px;
  }

  .legal-nav {
    display: grid;
    grid-column: span 2;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 4px 24px;
    padding: 0 12px;
  }

  .legal-nav a {
    font-size: 14px;
    font-weight: 400;
    line-height: 32px;
  }

  @media (max-width: 1279px) {
    .site-footer {
      padding: 64px 0 48px;
    }

    .footer-frame {
      padding: 0 32px;
    }

    .footer-main {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    .event-column {
      display: grid;
      grid-template-columns: minmax(0, 1fr) auto;
      gap: 24px;
      align-items: end;
      padding: 0;
    }

    .event-address {
      max-width: none;
      font-size: 16px;
      line-height: 30px;
    }

    .event-social-list {
      display: none;
    }

    .contacts-grid {
      display: flex;
      flex-direction: column;
      gap: 24px;
      padding-top: 24px;
      border-top: 1px solid rgba(255, 255, 255, 0.15);
    }

    .contact-column {
      padding: 0;
    }

    .contact-social-list {
      display: flex;
    }

    .footer-bottom {
      display: flex;
      flex-direction: column-reverse;
      gap: 36px;
    }

    .legal-nav {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 4px 24px;
      padding: 0;
    }

    .copyright {
      padding: 0;
    }
  }

  @media (max-width: 767px) {
    .site-footer {
      padding: 40px 0;
    }

    .footer-frame {
      padding: 0 32px;
    }

    .event-column {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: 24px;
    }

    .event-date {
      line-height: 1.2;
    }

    .event-address {
      font-size: 16px;
      line-height: 1.35;
    }

    .event-social-list {
      display: flex;
      justify-content: center;
    }

    .contact-social-list {
      display: none;
    }

    .contacts-grid {
      display: flex;
      flex-direction: column;
      gap: 36px;
      padding-top: 24px;
    }

    .contact-column h2 {
      font-size: 18px;
      line-height: 1.2;
    }

    .contact-column li {
      font-size: 16px;
      line-height: 1.25;
      white-space: nowrap;
    }

    .footer-separator {
      background: rgba(255, 255, 255, 0.15);
    }

    .legal-nav {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
  }
</style>
